import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    createHandlerChainRunnerOptionalParameter,
    executeAwaitableHandlerChain,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { updateAccount, UpdateAccountApiParameter } from "@insite/client-framework/Services/AccountService";
import loadCurrentAccount from "@insite/client-framework/Store/Data/Accounts/Handlers/LoadCurrentAccount";
import setInitialValues from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SetInitialValues";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";

import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";

export interface UpdateCustomAccountParameter {
    isCheckedForOrderConfirmationEmail: any;
}

type HandlerType = ApiHandlerDiscreteParameter<
    UpdateCustomAccountParameter,
    UpdateAccountApiParameter,
    AccountModel,
    { account: AccountModel }
>;

export const GetCurrentAccount: HandlerType = props => {
    const account = props.getState().pages.accountSettings.editingAccount;
    if (!account) {
        throw new Error("There was no current account when we are trying to save the current account");
    }
    props.account = account;
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        account: ({
            ...props.account,
            properties: {
                isUserOptedToGetOrderConfirmationEmail: props.parameter.isCheckedForOrderConfirmationEmail,
            } as object,
        } as unknown) as AccountModel,
    };
};

export const CallUpdateAccount: HandlerType = async props => {
    props.apiResult = await updateAccount(props.apiParameter);
};

export const LoadCurrentAccount: HandlerType = async props => {
    await executeAwaitableHandlerChain(loadCurrentAccount, {}, props);
};

export const SetInitialValues: HandlerType = props => {
    props.dispatch(setInitialValues());
};

export const chain = [GetCurrentAccount, PopulateApiParameter, CallUpdateAccount, LoadCurrentAccount, SetInitialValues];

const saveCurrentAccount = createHandlerChainRunner(chain, "saveCurrentAccount");

export default saveCurrentAccount;
